import { Form } from 'antd';
import styled from 'styled-components';

export const StyledForm = styled(Form)`
  .copy-content {
    background-color: #fbfbfb;
    border: 1px solid #dbdde2;
    margin: 0;
    width: 100%;
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 12px;
  }
  input {
    border: none !important;
    background-color: transparent !important;
    box-shadow: none !important;
    padding: 0 !important;
    padding-right: 4px !important;
    outline: 0;
  }
`;
